var LABEL_POSITION = {
  LEFT: 'left',
  NONE: 'none',
  TOP: 'top'
};
var TEXTFIELD_SIZE = {
  REGULAR: 'regular',
  SMALL: 'small',
  TINY: 'tiny'
};
var TEXTFIELD_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var TEXTFIELD_TYPE = {
  DATE: 'date',
  DATE_TIME: 'datetime-local',
  EMAIL: 'email',
  FILE: 'file',
  MONTH: 'month',
  PASSWORD: 'password',
  SEARCH: 'search',
  TEL: 'tel',
  TEXT: 'text',
  TIME: 'time',
  URL: 'url',
  WEEK: 'week'
};
var TEXTFIELD_TYPES_TO_PREVENT_CUSTOM_ADORNMENTS = [TEXTFIELD_TYPE.DATE, TEXTFIELD_TYPE.DATE_TIME, TEXTFIELD_TYPE.MONTH, TEXTFIELD_TYPE.PASSWORD, TEXTFIELD_TYPE.TIME, TEXTFIELD_TYPE.WEEK];

export { LABEL_POSITION, TEXTFIELD_SIZE, TEXTFIELD_TYPE, TEXTFIELD_TYPES_TO_PREVENT_CUSTOM_ADORNMENTS, TEXTFIELD_VARIANT };
//# sourceMappingURL=TextField.constants.js.map
